import { put, call, select, takeLatest } from 'redux-saga/effects';
import { Types, Creators } from './products-duck.js';
import { toast } from 'react-toastify';
import * as Api from './products-api.js';
import { Creators as GlobalCreators } from '../globals/globals-duck.js';
import toastApiError from 'utils/api-error.js';

export const getState = (state) => state.Product;

export function* fetchAsync() {
  try {
    yield put(GlobalCreators.globalsSetLoading(true));
    const state = yield select(getState);
    const response = yield call(Api.getProducts, state.filters);
    yield put(Creators.productsFetched(response.data));
  } catch (error) {
    toastApiError(error);
  } finally {
    yield put(GlobalCreators.globalsSetLoading(false));
  }
}

export function* fetchByIdAsync({ id, isClone = false }) {
  try {
    yield put(GlobalCreators.globalsSetLoading(true));
    const response = yield call(Api.getProductById, id);
    yield put(Creators.productFetched(response.data));
  } catch (error) {
    toastApiError(error);
  } finally {
    yield put(Creators.productOpenModal());
    if (isClone) {
      yield put(Creators.productClearId());
    }
    yield put(GlobalCreators.globalsSetLoading(false));
  }
}

export function* createAsync({ data }) {
  try {
    yield put(GlobalCreators.globalsSetLoading(true));
    yield call(Api.createProduct, data);
    toast.success('Produto criado com sucesso!');
  } catch (error) {
    toastApiError(error);
  } finally {
    yield fetchAsync();
    yield put(GlobalCreators.globalsSetLoading(false));
  }
}

export function* updateAsync({ id, data }) {
  try {
    yield put(GlobalCreators.globalsSetLoading(true));
    yield call(Api.updateProduct, id, data);
    toast.success('Produto atualizado com sucesso!');
  } catch (error) {
    toastApiError(error);
  } finally {
    yield fetchAsync();
    yield put(GlobalCreators.globalsSetLoading(false));
  }
}

export function* deleteAsync({ id }) {
  try {
    yield put(GlobalCreators.globalsSetLoading(true));
    yield call(Api.deleteProduct, id);
    toast.success('Produto excluído com sucesso!');
  } catch (error) {
    toastApiError(error);
  } finally {
    yield fetchAsync();
    yield put(GlobalCreators.globalsSetLoading(false));
  }
}

export function* fetchHighlightedAsync() {
  try {
    yield put(GlobalCreators.globalsSetLoading(true));
    const response = yield call(Api.getHighlightedProducts);
    yield put(Creators.productsFetchedHighlighted(response.data));
  } catch (error) {
    toastApiError(error);
  } finally {
    yield put(GlobalCreators.globalsSetLoading(false));
  }
}

export function* fetchStoreAsync({ filters }) {
  try {
    yield put(GlobalCreators.globalsSetLoading(true));
    const response = yield call(Api.getStoreProducts, filters);
    yield put(Creators.productsFetchedStore(response.data));
  } catch (error) {
    toastApiError(error);
  } finally {
    yield put(GlobalCreators.globalsSetLoading(false));
  }
}

export default [
  //Management
  takeLatest(Types.PRODUCTS_FETCH_ASYNC, fetchAsync),
  takeLatest(Types.PRODUCT_FETCH_BY_ID_ASYNC, fetchByIdAsync),
  takeLatest(Types.PRODUCT_CREATE_ASYNC, createAsync),
  takeLatest(Types.PRODUCT_UPDATE_ASYNC, updateAsync),
  takeLatest(Types.PRODUCT_DELETE_ASYNC, deleteAsync),

  // Store
  takeLatest(Types.PRODUCTS_FETCH_HIGHLIGHTED_ASYNC, fetchHighlightedAsync),
  takeLatest(Types.PRODUCTS_FETCH_STORE_ASYNC, fetchStoreAsync),
];
